/*
 * Allows you to toggle the Expert Neutral Deal-Closer via a checkbox and autosaves
 *
 * Expects params: { party: (json obj) }
 */
import React from 'react';
export default class ExpertNeutralToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expert_neutral_dealcloser: false
    };
  }

  componentDidMount() {
    this.loadEndPreference();
  }

  loadEndPreference() {
    $.ajax({
      url: '/api/v1/negotiations/' + this.props.negotiation_id + '/expert_neutral_dealcloser_preference',
      dataType: 'json',
      type: "GET",
      success: function(data) {
        this.setState({ expert_neutral_dealcloser: data.expert_neutral_dealcloser });
      }.bind(this)
    });
  }

  updateEndPreference() {
    var scope = this;

    var post_data = {
      expert_neutral_dealcloser: this.state.expert_neutral_dealcloser
    };

		$.ajax({
      url: '/api/v1/negotiations/' + this.props.negotiation_id + '/update_expert_neutral_dealcloser_preference',
      dataType: 'json',
      type: "PUT",
      data: post_data,
      success: function(data) {
        this.setState({ expert_neutral_dealcloser: data.expert_neutral_dealcloser });

        $.notify({
          icon: 'fa fa-check',
          title: 'Expert Neutral Preference Updated',
          message: ''
        },{ type: "success", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });

      }.bind(this),
      error: function(xhr, status, err) {

        $.notify({
          icon: 'fa fa-times',
          title: '',
          message: xhr.responseJSON || 'Failed to perfom action'
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      }.bind(this)
    });
  }

  handleInputChange(obj, event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    obj[name] = value;

    this.setState(this.state);
    this.updateEndPreference();
  }

  render() {
    var scope = this;

    return (
      <label className="checkbox-inline" style={{lineHeight: '15px'}}><input disabled={!this.props.end_enabled}type="checkbox" checked={this.state.expert_neutral_dealcloser} value={this.state.expert_neutral_dealcloser} name="expert_neutral_dealcloser" onChange={this.handleInputChange.bind(scope, scope.state)}  />&nbsp; {I18n.components.expert_neutral_toggle.i_agree_to_the_end}</label>
    );
  }
}
